import React from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';
const CATEGORIES = [{
  title: 'Wood Cabinet Doors',
  products: [{
    name: 'Mission Wood Cabinet Door',
    price: '$170.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/09/mission-natural-450x450.jpg'
  }, {
    name: 'Gothics Wood Cabinet Door',
    price: '$190.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/gothic-450x450.jpg'
  }, {
    name: 'Glazed Wood Cabinet Door',
    price: '$190.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/ezio-450x450.jpg'
  }, {
    name: 'Classic Wood Cabinet Door',
    price: '$150.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/09/classic-auburn-450x450.jpg'
  }]
}, {
  title: 'MDF Cabinet Doors',
  products: [{
    name: 'Taylor MDF Cabinet',
    price: '$199.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/taylar-2-3c02bc4-interwood-mobel-450x450.jpg'
  }, {
    name: 'Iris MDF Cabinet',
    price: '$210.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/irus-1-0656207-interwood-mobel-450x450.jpg'
  }, {
    name: 'Dune MDF Cabinet',
    price: '$220.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/dune-kitchen-6490af9-interwood-mobel-450x450.jpg'
  }, {
    name: 'Bianca MDF Cabinet',
    price: '$199.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/bianca-kitchen-1-2cc1643-interwood-mobel-450x450.jpg'
  }]
}, {
  title: 'Cabinet Accessories',
  products: [{
    name: 'Wall Storage Unit',
    price: '$85.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/wall-450x450.png'
  }, {
    name: 'Undersink Storage Unit',
    price: '$120.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/undersink-upper-storage-unit-for-kitchen-cabinets-afb11bc-interwood-mobel-450x450.png'
  }, {
    name: 'Jolly Basket',
    price: '$95.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/jolly-basket-450x450.png'
  }, {
    name: 'Detergent Basket',
    price: '$75.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/detergent-basket-for-laundry-and-dishwasher-42694c9-interwood-mobel-450x450.png'
  }]
}, {
  title: 'Handles and Knobs',
  products: [{
    name: 'Modern Bar Pull',
    price: '$12.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/51wzzpgmH3L._AC_US1000_-450x450.jpg'
  }, {
    name: 'Classic Round Knob',
    price: '$8.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/41OOkvXgZqL._AC_US1000_-450x450.jpg'
  }, {
    name: 'Sleek Edge Pull',
    price: '$15.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/716nejVwdCL._AC_SX466_-450x450.jpg'
  }, {
    name: 'Vintage Cup Pull',
    price: '$10.00',
    image: 'https://nkhomeimprovement.com/beta/wp-content/uploads/2022/10/41TmF4OkV-L._AC_US1000_-450x450.jpg'
  }]
}];
export function ProductsPage() {
  const {
    addToCart
  } = useCart();
  const handleAddToCart = (product: any) => {
    addToCart(product);
    toast.success(`${product.name} added to cart!`);
  };
  return <Layout data-id="element-506">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden" data-id="element-507">
        <div className="absolute inset-0 z-0" data-id="element-508">
          <img src="https://cdn.magicpatterns.com/uploads/sgmZdjGZcLDEeeSnLu77oo/image.png" alt="Store Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-509" />
          <div className="absolute inset-0 bg-black/20" data-id="element-510" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-511">
          Store
        </motion.h1>
      </section>

      {/* Store Content */}
      <div className="bg-white py-20 px-6" data-id="element-512">
        <div className="max-w-7xl mx-auto space-y-24" data-id="element-513">
          {CATEGORIES.map((category, catIdx) => <section key={catIdx} data-id="element-514">
              <h2 className="text-3xl md:text-4xl font-black text-[#6B0D24] text-center mb-16 uppercase tracking-tight" data-id="element-515">
                {category.title}
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16" data-id="element-516">
                {category.products.map((product, prodIdx) => <motion.div key={prodIdx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: prodIdx * 0.1
            }} className="flex flex-col items-center text-center group" data-id="element-517">
                    <div className="aspect-square w-full overflow-hidden bg-[#F5F5F5] mb-6 border border-charcoal/5" data-id="element-518">
                      <img src={product.image} alt={product.name} className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500" data-id="element-519" />
                    </div>

                    <h3 className="text-lg font-black text-charcoal leading-tight mb-2 uppercase tracking-tight" data-id="element-520">
                      {product.name}
                    </h3>

                    <p className="text-[#6B0D24] font-bold mb-6" data-id="element-521">
                      {product.price}
                    </p>

                    <button onClick={() => handleAddToCart(product)} className="bg-[#6B0D24] text-white px-8 py-3 font-black uppercase tracking-widest text-[10px] hover:bg-[#5A0B1E] transition-colors" data-id="element-522">
                      Add To Cart
                    </button>
                  </motion.div>)}
              </div>
            </section>)}
        </div>
      </div>
    </Layout>;
}